import { render, staticRenderFns } from "./CampaignJobSeekersResult.vue?vue&type=template&id=c7f84be2&scoped=true&"
import script from "./CampaignJobSeekersResult.vue?vue&type=script&lang=js&"
export * from "./CampaignJobSeekersResult.vue?vue&type=script&lang=js&"
import style0 from "./CampaignJobSeekersResult.vue?vue&type=style&index=0&id=c7f84be2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f84be2",
  null
  
)

export default component.exports